import { useCallback, useMemo } from 'react';
import { doChipStore } from '../store/doChipStore';
import { getKeyByValue } from '../helpers/getKeyByValue';
import { marketType } from '../enums/marketType';
import { parseNumberByPrecision } from '@pascal/pascal-core';
import { toJS } from 'mobx';
import { mathConfig, mathJS } from '../helpers/mathFormat';

export const useChip = () => {
  const { getAllBetsModels: allBetsModels } = doChipStore;
  const memoAllChipsTypes = useMemo(() => {
    const lastBetsModels = allBetsModels.length ? allBetsModels[0] : [];

    if (lastBetsModels.betModel) {
      return lastBetsModels?.betModel?.reduce((acc, curr) => {
        const { bet, includedBets } = curr;
        if (includedBets) {
          includedBets && acc.push(...includedBets.map((item) => getKeyByValue(marketType, item.type)));
        } else {
          acc.push(getKeyByValue(marketType, bet.type));
        }
        return acc;
      }, []);
    }
    return [];
  }, [allBetsModels]);

  const handleGetColumnChip = useCallback(
    (typeName) => {
      const lastBetsModels = allBetsModels.length ? allBetsModels[0] : [];

      if (lastBetsModels.betModel) {
        const allBets = lastBetsModels?.betModel?.reduce((acc, curr) => {
          const { bet, includedBets } = curr;
          if (includedBets) {
            acc.push(...includedBets);
          } else if (!includedBets) {
            acc.push(bet);
          }
          return acc;
        }, []);
        return allBets.reduce((acc, cur) => {
          if (getKeyByValue(marketType, cur.type) === typeName) {
            if (acc[typeName]) {
              acc[typeName] = parseNumberByPrecision(
                1,
                +mathJS.format(+(acc[typeName] + (cur.hasOwnProperty('winAmount') ? (cur.winAmount ? cur.winAmount : 0) : cur.amount)),
                  mathConfig),
              );
            } else {
              acc[typeName] = cur.hasOwnProperty('winAmount') ? (cur.winAmount ? cur.winAmount : 0) : cur.amount;
            }
          }
          return acc;
        }, {});
      }
    },
    [allBetsModels],
  );

  return {
    memoAllChipsTypes,
    handleGetColumnChip,
  };
};
